import { render, staticRenderFns } from "./Bannerads.vue?vue&type=template&id=01f7298f&scoped=true&"
import script from "./Bannerads.vue?vue&type=script&lang=js&"
export * from "./Bannerads.vue?vue&type=script&lang=js&"
import style0 from "./Bannerads.vue?vue&type=style&index=0&id=01f7298f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f7298f",
  null
  
)

export default component.exports